import React from 'react';
import DesktopNavBar from './DesktopNavBar';
import MobileNavBar from './MobileNavBar';
import { makeStyles } from '@material-ui/core/styles';
import { PATH_HOME, PATH_NOTES, PATH_LABS, PATH_SURVEYS, PATH_PROFILE, PATH_CHAT, PATH_CALENDAR } from '../../../containers/RoutePaths';
import { styleBreakMobile } from '../layouts/Globals';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useTheme from '@material-ui/core/styles/useTheme';

const isWatchman = process.env.REACT_APP_THEME_ENV === 'watchman';

const useStyles = makeStyles(theme => ({
    desktop: {
        [theme.breakpoints.down(theme.breakpoints.values['lg'])]: {
            display: 'none',
        },
    },
    mobile: {
        [theme.breakpoints.up(theme.breakpoints.values['lg'])]: {
            display: 'none',
        },
    },
}));

export function MenuLinks() {
    const theme = useTheme();
    const isMobile = useMediaQuery(styleBreakMobile(theme));

    const menuLinks = [
        { link: PATH_HOME, text: 'Home' },
        { link: PATH_LABS, text: 'Labs' },
        { link: PATH_NOTES, text: 'Notes' },
        { link: PATH_PROFILE, text: isWatchman ? 'Settings' : 'Profile' },
    ];

    if (isWatchman) {
        if (isMobile) {
            menuLinks.splice(3, 0, { link: PATH_CHAT, text: 'Chat' });
        }
        menuLinks.splice(3, 0, { link: PATH_CALENDAR, text: 'Calendar' });
    } else {
        menuLinks.splice(2, 0, { link: PATH_SURVEYS, text: 'Surveys' });
    }

    return menuLinks;
}

export default function AdaptiveNavBar({ mobilePresent, isErrorPageHeader, showAlertModal, links = MenuLinks() }) {
    const classes = useStyles();

    return (
        <>
            {mobilePresent ? (
                <div className={classes.mobile}>
                    <MobileNavBar isErrorPageHeader={isErrorPageHeader} />
                </div>
            ) : null}
            <div className={classes.desktop}>
                <DesktopNavBar linkObj={links} isErrorPageHeader={isErrorPageHeader} showAlertModal={showAlertModal} />
            </div>
        </>
    );
}
